import { render, staticRenderFns } from "./FollowUp.vue?vue&type=template&id=3f157646&scoped=true&"
import script from "./FollowUp.vue?vue&type=script&lang=ts&"
export * from "./FollowUp.vue?vue&type=script&lang=ts&"
import style0 from "./FollowUp.vue?vue&type=style&index=0&id=3f157646&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f157646",
  null
  
)

export default component.exports